module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex"
  }, [_c('x-header', [_vm._v("\n        银行卡号列表 (" + _vm._s(this.bankCardList.length) + "/" + _vm._s(_vm.limitNumber) + ")\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "flex-content"
  }, [_c('div', [_c('div', [(_vm.bankCardList.length) ? _c('group', {
    attrs: {
      "title": "向左滑动可编辑和删除银行卡"
    }
  }, [_c('swipeout', _vm._l((_vm.bankCardList), function(item, index) {
    return _c('swipeout-item', {
      key: item.id,
      attrs: {
        "transition-mode": "follow"
      }
    }, [_c('div', {
      attrs: {
        "slot": "right-menu"
      },
      slot: "right-menu"
    }, [_c('swipeout-button', {
      attrs: {
        "type": "primary"
      },
      nativeOn: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.onButtonClick('edit', item, index)
        }
      }
    }, [_vm._v("编辑\n                                ")]), _vm._v(" "), _c('swipeout-button', {
      attrs: {
        "type": "warn"
      },
      nativeOn: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.onButtonClick('delete', item, index)
        }
      }
    }, [_vm._v("\n                                    删除\n                                ")])], 1), _vm._v(" "), _c('div', {
      staticClass: "bankCard-item-box",
      attrs: {
        "slot": "content"
      },
      slot: "content"
    }, [_c('div', {
      staticClass: "bankCard-l1"
    }, [_c('span', {
      staticStyle: {
        "color": "#d4880f",
        "padding-right": "10px"
      }
    }, [_vm._v(_vm._s(item.holder_name))]), _vm._v(_vm._s(item.holder_mobile) + "\n                                ")]), _vm._v(" "), _c('div', {
      staticClass: "bankCard-l2"
    }, [_vm._v("\n                                    " + _vm._s(item.bank_name) + "\n                                    "), _c('br'), _vm._v("\n                                    " + _vm._s(item.card_no) + "\n                                ")])])])
  }))], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "15px 5px"
    }
  }, [_c('x-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.bankCardList.length >= _vm.limitNumber
    },
    nativeOn: {
      "click": function($event) {
        _vm.addbankCard()
      }
    }
  }, [_vm._v("增加银行卡号\n                ")])], 1)]), _vm._v(" "), _c('popup', {
    staticStyle: {
      "height": "100%",
      "overflow": "auto"
    },
    attrs: {
      "position": "right",
      "width": "100%"
    },
    model: {
      value: (_vm.showEditbankCard),
      callback: function($$v) {
        _vm.showEditbankCard = $$v
      },
      expression: "showEditbankCard"
    }
  }, [_c('x-header', {
    attrs: {
      "left-options": {
        preventGoBack: true
      }
    },
    on: {
      "on-click-back": function($event) {
        _vm.showEditbankCard = false
      }
    }
  }, [_vm._v("银行卡号编辑\n            ")]), _vm._v(" "), _c('div', [_c('group', {
    attrs: {
      "title": "持卡人姓名"
    }
  }, [_c('x-input', {
    attrs: {
      "placeholder": "中文(必填)",
      "placeholder-align": "left"
    },
    model: {
      value: (_vm.formbankCard['holder_name']),
      callback: function($$v) {
        _vm.$set(_vm.formbankCard, 'holder_name', $$v)
      },
      expression: "formbankCard['holder_name']"
    }
  })], 1), _vm._v(" "), _c('group', {
    attrs: {
      "title": "持卡人手机号码"
    }
  }, [_c('x-input', {
    attrs: {
      "max": 11,
      "is-type": "china-mobile",
      "placeholder": "11位数字(必填)",
      "placeholder-align": "left"
    },
    model: {
      value: (_vm.formbankCard['holder_mobile']),
      callback: function($$v) {
        _vm.$set(_vm.formbankCard, 'holder_mobile', $$v)
      },
      expression: "formbankCard['holder_mobile']"
    }
  })], 1), _vm._v(" "), _c('group', {
    attrs: {
      "title": "银行卡号"
    }
  }, [_c('x-input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.formbankCard['card_no']),
      callback: function($$v) {
        _vm.$set(_vm.formbankCard, 'card_no', $$v)
      },
      expression: "formbankCard['card_no']"
    }
  })], 1), _vm._v(" "), _c('group', {
    attrs: {
      "title": "银行名称"
    }
  }, [_c('x-textarea', {
    attrs: {
      "placeholder": "如：中国建设银行四川省分行绵阳市支行金三角分理处"
    },
    model: {
      value: (_vm.formbankCard['bank_name']),
      callback: function($$v) {
        _vm.$set(_vm.formbankCard, 'bank_name', $$v)
      },
      expression: "formbankCard['bank_name']"
    }
  })], 1), _vm._v(" "), _c('group', {
    attrs: {
      "title": "银行行号"
    }
  }, [_c('x-input', {
    attrs: {
      "placeholder": "一般为12位数字，请致电银行询问",
      "placeholder-align": "left"
    },
    model: {
      value: (_vm.formbankCard['bank_id']),
      callback: function($$v) {
        _vm.$set(_vm.formbankCard, 'bank_id', $$v)
      },
      expression: "formbankCard['bank_id']"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "40px",
      "padding": "10px"
    }
  }, [_c('x-button', {
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        _vm.postbankCard()
      }
    }
  }, [_vm._v("提交")]), _vm._v(" "), _c('x-button', {
    attrs: {
      "type": "default"
    },
    nativeOn: {
      "click": function($event) {
        _vm.showEditbankCard = false
      }
    }
  }, [_vm._v("返回")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5631ab3c"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/uc/BankCard.vue
// module id = 694
// module chunks = 0